<template>
    <v-card>
        <v-card-title>
            <v-icon color="primary"> mdi-badge-account-outline </v-icon>
            <span class="px-2">{{ student.name }}</span>
            <v-chip v-if="student.status_id" class="mx-2" small dark :color="statusColor">
                {{ statusText }}
            </v-chip>
            <v-spacer></v-spacer>
            <!-- the parent's page listed the children by name only, so seeing
                 anything about one meant searching the students list for it -->
            <v-btn small depressed color="primary" @click="viewStudent">
                {{ $t('view') }}
                <v-icon right small>mdi-eye</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text class="my-4">
            <v-row>
                <v-col cols="12" md="3" v-if="student.avatar">
                    <div class="d-flex justify-center">
                        <avatar-image-component
                            :edit="false"
                            :avatarUrl="student.avatar"
                            :user="student.id"
                        ></avatar-image-component>
                    </div>
                </v-col>
                <v-col cols="12" md="9">
                    <v-row class="mx-2 mt-1">
                        <v-col cols="12" md="6">
                            <p class="font-weight-bold">{{ $t('student_id') }}</p>
                            <div class="mt-4">
                                <p>{{ student.student_identification }}</p>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <p class="font-weight-bold">{{ $t('registered') }}</p>
                            <div class="mt-4">
                                <p>
                                    {{ student.created_at | moment("LL") }} -
                                    {{ student.created_at | moment("LT") }}
                                </p>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="mx-2 mt-1">
                        <v-col cols="12" md="6">
                            <p class="font-weight-bold">{{ $t('route') }}</p>
                            <div class="mt-4">
                                <v-chip small dark :color="isMapped ? 'success' : 'warning'">
                                    {{ isMapped ? $t('mapped') : $t('not_mapped') }}
                                </v-chip>
                            </div>
                        </v-col>
                        <v-col v-if="school" cols="12" md="6">
                            <p class="font-weight-bold">{{ $t('school') }}</p>
                            <div class="mt-4">
                                <p>{{ school }}</p>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row v-if="student.notes" class="mx-2 mt-2">
                        <v-col cols="12">
                            <p class="font-weight-bold">{{ $t('notes') }}</p>
                            <div class="mt-4">
                                <p>{{ student.notes }}</p>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import AvatarImageComponent from "../../components/AvatarImageComponent.vue";

export default {
    name: "studentCard",
    props: {
        student: {
            type: Object,
            required: true,
        },
    },
    components: {
        AvatarImageComponent,
    },
    computed: {
        //a student rides only once they have both a pickup and a drop-off point
        isMapped() {
            const settings = this.student.student_settings;
            if (!settings) return false;
            return !!settings.pickup_trip_id && !!settings.drop_off_trip_id;
        },
        school() {
            return this.student.student_school ? this.student.student_school.name : null;
        },
        statusText() {
            return this.$t(
                {
                    1: "active",
                    2: "pending",
                    3: "suspended",
                    4: "under_review",
                    5: "out_of_coins",
                }[this.student.status_id] || "active"
            );
        },
        statusColor() {
            return { 1: "success", 2: "warning", 3: "error", 4: "error", 5: "error" }[
                this.student.status_id
            ] || "success";
        },
    },
    methods: {
        viewStudent() {
            this.$router.push({
                name: "view-student",
                params: { user_id: this.student.id },
            });
        },
    },
};
</script>
